var React = require('react');

function RightBackInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("polygon",{"id":"Path-2","fill":"#D2F7D7","fillRule":"nonzero","points":"0 0 1420 0 1420 946"}))]);
}

RightBackInline.defaultProps = {"viewBox":"0 0 1420 946","version":"1.1"};

module.exports = RightBackInline;

RightBackInline.default = RightBackInline;
